module.exports = __webpack_public_path__ + "img/dataAssetNameSpecialty.b1567d3c.png";